import { render, staticRenderFns } from "./BlockAndDeleteOperator.vue?vue&type=template&id=ad828b34&scoped=true"
import script from "./BlockAndDeleteOperator.vue?vue&type=script&lang=ts"
export * from "./BlockAndDeleteOperator.vue?vue&type=script&lang=ts"
import style0 from "./BlockAndDeleteOperator.vue?vue&type=style&index=0&id=ad828b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad828b34",
  null
  
)

export default component.exports